const Colors = {
  PINK: '#ffa789',
  ORANGE: '#f4b869',
  LIGHT_ORANGE: '#f4cb87',
  DARK_ORANGE: '#f0a35b',
  VERY_LIGHT_ORANGE: '#f7cd96',
  BLUE: '#A0B4C7',
  BROWN: '#806961'
};

export default Colors;
